import { useEffect, useState } from "react";
import i18n from "../../../lib/i18n";
import { GetFeaturesByIdData } from "../../../lib/data";
import { useParams } from "react-router-dom";
import EditPagesSectionUi from "../../../ui/FeaturesUi/editFeaturesUi";

export default function EditFeatures() {

    const {featureId} = useParams();
    const [pagesSectionData, setPagesSectionData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const pageSectionData = await GetFeaturesByIdData(featureId);
        setPagesSectionData({});
        setPagesSectionData(pageSectionData);
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.features")} </h1>
                <EditPagesSectionUi data={pagesSectionData} />
            </div>
        </div>
    );
};